import styled from 'styled-components';

export const PageNotFoundContainer = styled.div``;
